export default __webpack_public_path__ + "static/media/business-prints.b1509285.jpeg";